// extracted by mini-css-extract-plugin
export var hero = "Logo-module--hero--5ijXz";
export var layers = "Logo-module--layers--iBXQZ";
export var singlePath = "Logo-module--single-path--I5SnM";
export var paths = "Logo-module--paths--x5mgG";
export var movement = "Logo-module--movement---njbE";
export var opacity = "Logo-module--opacity--QrpEv";
export var font = "Logo-module--font--1dhAb";
export var glitch = "Logo-module--glitch--EGC66";